export default __webpack_public_path__ + "static/media/profile.3d82eff0.png";